module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-90.a78badb.woff2";